<template>
  <div id="app_signup">
    <v-layout wrap>
      <v-flex xs12 md12 pa-8>
        <v-card id="app_height" outlined tile>
          <passwordMain v-if="winStep == 0" @stepper="winStepper" />
					<mailSend v-if="winStep == 1"/>
          <passwordSuccess v-bind:loginData="loginData" v-if="winStep == 2" />
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import passwordMain from "../Password/passwordMain";
import mailSend from '../Password/mailSend'
import passwordSuccess from "../Password/passwordSuccess";

export default {
  components: {
		passwordMain,
		mailSend,
    passwordSuccess
  },
  data() {
    return {
      winStep: 0,
      msg: null
    };
  },
  methods: {
    winStepper(window_data) {
      this.winStep = window_data.winStep;
    }
  }
};
</script>

<style scoped>
#app_signup {
  background-image: url("../../assets/home_header.png");
  /* background-color: #26af82; */
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}
@media only screen and (min-width: 800px) {
  #app_height {
    min-height: 80vh;
  }
}
</style>
